<template>
  <footer class="pt-footer">
    <div class="pt-footer__inner">
      <p>版权所有：中国交通运输协会</p>
      <p>地址：北京市西城区广安门内大街315号信息大厦B座6-7层&emsp;wlb@cctaw.cn</p>
      <p>
        Copyright 2004-2030 中国交通运输协会 All rights reserved &emsp;
        <a class="pt-footer__link" href="https://beian.miit.gov.cn" target="_blank">京ICP备19025043号-1</a>
      </p>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'AppFooter'
}
</script>

<style lang="less" scoped>
.pt-footer {
  background: #0A447C;
  color: rgba(255, 255, 255, 0.85);
}
.pt-footer__inner {
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  padding: 32px 16px;
  text-align: center;
  font-size: 12px;
  line-height: 28px;
}
.pt-footer__inner p {
  margin: 0;
}
.pt-footer__link {
  color: rgba(255, 255, 255, 0.85);
  text-decoration: none;
  transition: text-decoration 0.2s;
}
.pt-footer__link:hover {
  text-decoration: underline;
}

@media (min-width: 640px) {
  .pt-footer__inner {
    padding: 40px 16px;
    font-size: 14px;
  }
}
</style>
